// IHG's own spend taxonomy, pre-seeded per the intake change spec (change 5):
// the buyer's category trees — Product & Technology, Commercial & Marketing,
// Professional Services — replace the generic supplier-type list.

export interface IhgCategory {
    id: string;
    label: string;
}

export interface IhgCategoryGroup {
    id: string;
    label: string;
    categories: IhgCategory[];
}

export const IHG_TAXONOMY: IhgCategoryGroup[] = [
    {
        id: "product_technology",
        label: "Product & Technology",
        categories: [
            { id: "cloud_infrastructure", label: "Cloud & Infrastructure" },
            { id: "software_saas", label: "Software & SaaS" },
            { id: "cybersecurity", label: "Cybersecurity" },
            { id: "property_management_systems", label: "Property Management Systems" },
            { id: "guest_wifi_connectivity", label: "Guest Wi-Fi & Connectivity" },
            { id: "data_analytics_platforms", label: "Data & Analytics Platforms" },
        ],
    },
    {
        id: "commercial_marketing",
        label: "Commercial & Marketing",
        categories: [
            { id: "influencer_creator_platforms", label: "Influencer & Creator Platforms" },
            { id: "media_advertising_agencies", label: "Media & Advertising Agencies" },
            { id: "loyalty_crm_platforms", label: "Loyalty & CRM Platforms" },
            { id: "brand_creative_services", label: "Brand & Creative Services" },
            { id: "market_research", label: "Market Research" },
            { id: "digital_marketing_technology", label: "Digital Marketing Technology" },
        ],
    },
    {
        id: "professional_services",
        label: "Professional Services",
        categories: [
            { id: "management_consulting", label: "Management Consulting" },
            { id: "legal_services", label: "Legal Services" },
            { id: "financial_audit_services", label: "Financial & Audit Services" },
            { id: "staffing_recruitment", label: "Staffing & Recruitment" },
            { id: "training_development", label: "Training & Development" },
        ],
    },
];

export function findIhgCategory(
    categoryId: string | undefined
): { group: IhgCategoryGroup; category: IhgCategory } | undefined {
    if (!categoryId) return undefined;
    for (const group of IHG_TAXONOMY) {
        const category = group.categories.find((c) => c.id === categoryId);
        if (category) return { group, category };
    }
    return undefined;
}

/** "Commercial & Marketing › Influencer & Creator Platforms" */
export function ihgCategoryDisplay(categoryId: string | undefined): string {
    const found = findIhgCategory(categoryId);
    return found ? `${found.group.label} › ${found.category.label}` : "—";
}
